import React from 'react';

interface CustomIconProps {
  filled?: boolean;
  color?: string;
  width?: string;
}

const CourseArrowIcon: React.FC<CustomIconProps> = () => (
  <svg
    width={20}
    height={20}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.99996 1.67188C5.39996 1.67188 1.66663 5.40521 1.66663 10.0052C1.66663 14.6052 5.39996 18.3385 9.99996 18.3385C14.6 18.3385 18.3333 14.6052 18.3333 10.0052C18.3333 5.40521 14.6 1.67188 9.99996 1.67188ZM12.9416 10.8635L10.4416 13.3635C10.3166 13.4885 10.1583 13.5469 9.99996 13.5469C9.84163 13.5469 9.68329 13.4885 9.55829 13.3635L7.05829 10.8635C6.81663 10.6219 6.81663 10.2219 7.05829 9.98021C7.29996 9.73854 7.69996 9.73854 7.94163 9.98021L9.37496 11.4135V7.08854C9.37496 6.74688 9.65829 6.46354 9.99996 6.46354C10.3416 6.46354 10.625 6.74688 10.625 7.08854V11.4135L12.0583 9.98021C12.3 9.73854 12.7 9.73854 12.9416 9.98021C13.1833 10.2219 13.1833 10.6219 12.9416 10.8635Z'
      fill='#4ADE80'
    />
  </svg>
);

export default CourseArrowIcon;
